import { createSelector } from "reselect";
import inRange from "lodash/inRange";
import orderBy from "lodash/orderBy";

export const updatedDataSelector = state => state.table.updatedData;
const dateRangeSelector = state => state.tableDateRange;
const sortingSelector = state => state.table.sort;
const filterSelector = state => state.table.filter;

const convertDisplayedOrderBy = (orderBy) => {
  if (orderBy === 'displayTimestamp') {
    return 'timestamp';
  }

  if (orderBy === 'displayStart') {
    return 'start';
  }

  if (orderBy === 'displayEnd') {
    return 'end';
  }
  return orderBy;
};

const getData = (data, selectedDateRange, selectedSorting, selectedFilter) => {
  const { startDate, endDate } = selectedDateRange;
  const { maxPkEnergy } = selectedFilter;
  const startUnix = startDate.unix() * 1000;
  const endUnix = endDate.unix() * 1000;

  const dataSet = [...data];

  // handle time range and Pmax filtering
  let selectedData = dataSet.filter(item => {
    const time = item.timestamp || item.start;
    if (item.customer_peak_max_kwh) {
      return (
        item.customer_peak_max_kwh > maxPkEnergy &&
        inRange(time, startUnix, endUnix)
      );
    }

    return inRange(time, startUnix, endUnix);
  });

  // handle sorting
  return orderBy(
    selectedData,
    convertDisplayedOrderBy(selectedSorting.orderBy),
    selectedSorting.order
  );
};

export default createSelector(
  updatedDataSelector,
  dateRangeSelector,
  sortingSelector,
  filterSelector,
  getData
);



// WEBPACK FOOTER //
// ./src/selectors/selected_table_data.js